export default {
    standard: 0,
    umbrella: 1
}
